// Data access seam for the art collection.
//
// Today the collection is a compile-time constant, so this is a pass-through.
// It exists so that consumers never import the constant directly: when the
// backend lands, `getCollection()` becomes a fetch against `apiUrl('collection')`
// and this is the only file that changes.
//
// Kept synchronous deliberately. CollectionMasonry initialises jQuery Masonry
// and the lightbox against the rendered DOM, so making this async requires
// reworking that init order — a separate change, not a drive-by.

import { CollectionCollage } from '../components/pages/Constants';

export const getCollection = () => CollectionCollage;
